import { render, staticRenderFns } from "./AddObject.vue?vue&type=template&id=bbe8adb8&scoped=true&"
import script from "./AddObject.vue?vue&type=script&lang=js&"
export * from "./AddObject.vue?vue&type=script&lang=js&"
import style0 from "./AddObject.vue?vue&type=style&index=0&id=bbe8adb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe8adb8",
  null
  
)

export default component.exports